import { useHeaderContext } from '@/sinister/header/contexts/HeaderContext'
import Icon from '@mercadoni/sinister/dist/cjs/Icon'
import { FC } from 'react'
import Text from './decorators/Text'
import styles from './layout.module.css'

interface FavoritesLayoutProps {
  className?: string
}

const FavoritesLayout: FC<FavoritesLayoutProps> = ({ className }) => {
  const {
    onClickFavorites,
    copies: { header: copy },
    isMobile,
  } = useHeaderContext()

  const buttonClassName = isMobile
    ? `${styles.buttonMobile} ${className || ''}`
    : `${styles.button} ${className || ''}`

  return (
    <button onClick={onClickFavorites} className={buttonClassName}>
      <Icon className="ph-heart" size={24} />
      {!isMobile && <Text>{copy?.favorites}</Text>}
    </button>
  )
}

export default FavoritesLayout
